import { type ActionType } from "../../../redux/types";
import { UPDATE_NAVIGATIONBREADCRUMS } from "./actions";
import { type BreadcrumbItem } from "../NavigationBreadcrumbs";

export interface NavigationBreadcrumbsState {
  list: BreadcrumbItem[];
}

const INITIAL_STATE: NavigationBreadcrumbsState = {
  list: [],
};

export const navigationBreadcrumbsReducer = (
  state: NavigationBreadcrumbsState = INITIAL_STATE,
  action: ActionType<any>
): NavigationBreadcrumbsState => {
  switch (action.type) {
    case UPDATE_NAVIGATIONBREADCRUMS: {
      return {
        list: action.payload.breadcrumbs,
      };
    }

    default: {
      return state;
    }
  }
};
